export const FETCH_LOAD_OWNER_BY_OWNER_ID_REQUEST = 'FETCH_LOAD_OWNER_BY_OWNER_ID_REQUEST'
export const FETCH_LOAD_OWNER_BY_OWNER_ID_SUCCESS = 'FETCH_LOAD_OWNER_BY_OWNER_ID_SUCCESS'
export const FETCH_LOAD_OWNER_BY_OWNER_ID_FALUIRE = 'FETCH_LOAD_OWNER_BY_OWNER_ID_FALUIRE'
export const FETCH_CLEAR_OWNER_BY_OWNER_ID = 'FETCH_CLEAR_OWNER_BY_OWNER_ID'
